import { disbusementService } from '../_services'

const state = {
    data: {}
}

const actions = {
    calc ({ commit }, data) {
        commit('getAllRequest')
        disbusementService.calc(data)
            .then(
                response => commit('getAllSuccess', response.data.data),
                error => commit('getAllFailure', error)
            )
    }
}

const mutations = {
    getAllRequest (state) {
        state.data = { loading: true }
    },
    getAllSuccess (state, result) {
        state.data = { mapped: result.mapped, total: result.total }
    },
    getAllFailure (state, error) {
        state.data = { error }
    }
}

export const disbursement = {
    namespaced: true,
    state,
    actions,
    mutations
}
